import Hero from "../Hero/Hero";
import Promo from "../Promo/Promo";
import Services from "../Services/Services";
import Process from "../Process/Process";
import Reviews from "../Reviews/Reviews";
import Pricing from "../Pricing/Pricing";
import Contact from "../Contact/Contact";
import React, {useState} from "react";
import PDFModal from "../PDFModal/PDFModal";
import AppInstallModal from "../AppInstallModal/AppInstallModal";

const Home = () => {

    const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
    const [isAppInstallModalOpen, setIsAppInstallModalOpen] = useState(false);

    const handleSamplePDFClick = () => {
        setIsPDFModalOpen(true);
    };

    const handleAppInstallClick = () => {
        setIsAppInstallModalOpen(true);
    };


    return (
        <>
            <Hero onAppInstallClick={handleAppInstallClick} />
            <Promo />
            <Services />
            <Process onSamplePDFClick={handleSamplePDFClick} />
            <Reviews />
            {/* <FAQ /> */}
            {/*2025 08 08 임시 주석처리*/}
            <Pricing />
            <Contact />
            {/* 모달들 */}
            <PDFModal
                isOpen={isPDFModalOpen}
                onClose={() => setIsPDFModalOpen(false)}
            />
            <AppInstallModal
                isOpen={isAppInstallModalOpen}
                onClose={() => setIsAppInstallModalOpen(false)}
            />
        </>
    )
}

export default Home